module.exports = __webpack_public_path__ + "img/hr-puberty-decal-26.aa76e445.png";